module.exports = __webpack_public_path__ + "static/fonts/Fact-ExpandedMedium.506984c.woff";